/**
 * Created by fyzu on 25.07.16.
 */

let debug = (function () {

    'use strict';

    let logOn = false;

    function setDebug(value) {
        logOn = value;
    }

    function log(value) {
        if (logOn) {
            console.log(value);
        }
    }

    return {
        setDebug: setDebug,
        log: log
    };
})();

let DishesService = (function () {

    'use strict';

    //************ Variables ************//
    let favorites;
    let categoryPath;
    let itemGroups = {};
    let isFavoritesPage;
    let addedImpressions = [];
    const XS_MAX_WIDTH = 767;
    const QUANTITY_TO_SEND_TO_THE_ANALYST = 6;

    //************ Functions ************//
    function CreateItem(parent, element) {

        //************ Variables ************//
        let count = parseInt($(element.find('.js-dishes-item-count')[0]).text());

        //************ Functions ************//
        function getCount() {
            return parseInt(count);
        }

        function setCount(value) {
            count = parseInt(value);
            if (count < 0) {
                count = 0;
            }

            element.find('.js-dishes-item-count').text(count);

            let cart = parent.getElement().find('.js-dishes-in-cart');
            if (parent.getCount() === 0) {
                cart.addClass('mod-hidden');
            } else {
                cart.removeClass('mod-hidden');
            }
        }

        //************ Public ************//
        return {
            getCount: getCount,
            setCount: setCount,
        };
    }

    function CreateItemGroup() {

        //************ Variables ************//
        let groupElement

        let id = "";
        let element = {};
        let items = {};
        /**
         * Если это предмет с добавками или выбором, то это поле нужно для отображения числа пользователю(и ничего более)
         */
        let chooseItemCounter = -1;
        let count = 0;
        let callback = null;

        //************ Functions ************//
        /**
         * Чисто визуальный метод, ни на какую логику не влияет
         * Устанавливает кол-во у товара с выбором чего либо(айтемов или добавок)
         */
        function setChooseItemCount(value) {
            chooseItemCounter = value;

            let counter = groupElement.find(".js-choose-catalog_count");
            if (value > 0) {
                counter.css("display", "");
                counter.html(value);
            } else
                counter.hide();
        }

        function getChooseItemCounter() {
            return chooseItemCounter;
        }

        function setGroupElement(setGroupElement) {
            groupElement = setGroupElement;
        }

        function setId(value) {
            id = value;
        }

        function getId() {
            return id;
        }

        function setElement(value) {
            element = value;
            count = parseInt(element.find('.js-dishes-count').text());
        }

        function getElement() {
            return element;
        }

        function setItems(value) {
            items = value;
        }

        /**
         * Метод для обычных айтемов, без выбора
         * Если нужно кол-во добавок, то используем getChooseItemCounter
         * @returns {number}
         */
        function getCount() {
            let count = 0;
            for (let key in items) {
                if (items.hasOwnProperty(key)) {
                    count += items[key].getCount();
                }
            }
            return count;
        }

        function setCallback(value) {
            callback = value;
        }

        function setAddonItem(itemId, count, addons = []) {

            if (count > 0) {
                AnimationsService.animate.basket();
            }

            BasketService.requestAddItem(id, itemId, count, addons);

            setChooseItemCount(getChooseItemCounter() + count);
        }

        function addItem(itemId) {
            debug.log('Item inc: id - ' + id + ', itemId: ' + itemId);
            let item = items[itemId];

            let itemCount = item.getCount();
            if (itemCount === 0) {
                AnimationsService.animate.basket();
            }
            item.setCount(itemCount + 1);

            BasketService.requestSet(id, itemId, item.getCount());
            if (Object.keys(items).length > 1) {
                element.find('.js-dishes-count').text(getCount());
            }
        }

        function removeItem(itemId) {

            debug.log('Item inc: id - ' + id + ', itemId: ' + itemId);
            items[itemId].setCount(items[itemId].getCount() - 1);

            BasketService.requestSet(id, itemId, items[itemId].getCount());
            if (Object.keys(items).length > 1) {
                element.find('.js-dishes-count').text(getCount());
            }
        }

        //************ Public ************//
        return {
            setGroupElement: setGroupElement,
            setId: setId,
            getId: getId,
            setElement: setElement,
            getElement: getElement,
            setItems: setItems,
            getCount: getCount,
            setCallback: setCallback,
            addItem: addItem,
            removeItem: removeItem,
            setItem: setAddonItem,
            setAddonItem: setAddonItem,
            setChooseItemCount: setChooseItemCount,
            getChooseItemCounter: getChooseItemCounter
        };
    }

    function showPreview(src) {
        let previewEl = $('#js-dishes-preview');
        previewEl.find('img').prop('src', src);
        previewEl.show();
    }

    function ecommerceBeforeModal(list, itemGroupId, name, price, category, position) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceClick',
            'ecommerce': {
                'click': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': itemGroupId,
                            'price': price,
                            'category': category,
                            'position': position
                        }
                    ]
                }
            }
        });
    }

    function ecommerceAfterModal(list, itemGroupId, name, price, category) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceDetail',
            'ecommerce': {
                'detail': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': itemGroupId,
                            'price': price,
                            'category': category
                        }
                    ]
                }
            }
        });
    }

    function ecommerceClick(isAddition, count, itemGroupId, name, price, category) {
        if (isAddition) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceAdd',
                'ecommerce': {
                    'add': {
                        'products': [
                            {
                                'name': name,
                                'id': itemGroupId,
                                'price': price,
                                'category': category,
                                'quantity': 1
                            }
                        ]
                    }
                }
            });
        } else {
            if (count !== 0) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'ecommerceRemove',
                    'ecommerce': {
                        'remove': {
                            'products': [
                                {
                                    'name': name,
                                    'id': itemGroupId,
                                    'price': price,
                                    'category': category,
                                    'quantity': 1
                                }
                            ]
                        }
                    }
                });
            }
        }
    }

    function ecommerceVariantBeforeModal(list, itemGroupId, name, price, category, position, variant) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceClick',
            'ecommerce': {
                'click': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': itemGroupId,
                            'price': price,
                            'category': category,
                            'variant': variant,
                            'position': position
                        }
                    ]
                }
            }
        });
    }

    function ecommerceVariantAfterModal(list, itemGroupId, name, price, category, variant) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceDetail',
            'ecommerce': {
                'detail': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': itemGroupId,
                            'price': price,
                            'category': category,
                            'variant': variant
                        }
                    ]
                }
            }
        });
    }

    function ecommerceClickVariant(isAddition, count, itemGroupId, name, price, category, variant) {
        if (isAddition) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceAdd',
                'ecommerce': {
                    'add': {
                        'products': [
                            {
                                'name': name,
                                'id': itemGroupId,
                                'price': price,
                                'category': category,
                                'variant': variant,
                                'quantity': 1
                            }
                        ]
                    }
                }
            });
        } else {
            if (count !== 0) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'ecommerceRemove',
                    'ecommerce': {
                        'remove': {
                            'products': [
                                {
                                    'name': name,
                                    'id': itemGroupId,
                                    'price': price,
                                    'category': category,
                                    'variant': variant,
                                    'quantity': 1
                                }
                            ]
                        }
                    }
                });
            }
        }
    }

    function ecommerceImpressions() {
        let impressions = [];
        let position = addedImpressions.length + 1;
        let newItemView = false;
        let item;

        $('.dishes-item').each(function () {
            let groupElement = $(this);
            let name = groupElement.data('name');
            let itemGroupId = groupElement.data('itemGroupId');
            let price = groupElement.data('price');
            let category = groupElement.data('category');
            let list = groupElement.data('list');

            if ($(window).width() > XS_MAX_WIDTH) {
                // Логика для экранов с шириной больше 767px. Товар отправляется в аналитику, если хоть немного виден
                // пользователю.

                if (isIntoView(groupElement)) {
                    if (!addedImpressions.includes(itemGroupId)) {
                        addItem(itemGroupId, name, price, category, list);
                    }
                }
            } else {
                // Логика для экранов с шириной меньше 768px. Товары отправляются по 6 штук за раз. Как только
                // пользователю становится виден ещё не отправленный в аналитику товар, отправляются следующие 6
                // товаров, начиная с нового.

                if (!newItemView) {
                    if (isIntoView(groupElement)) {
                        if (!addedImpressions.includes(itemGroupId)) {
                            addItem(itemGroupId, name, price, category, list);
                            newItemView = true;
                        }
                    }
                } else if (impressions.length < QUANTITY_TO_SEND_TO_THE_ANALYST) {
                    if (!addedImpressions.includes(itemGroupId)) {
                        addItem(itemGroupId, name, price, category, list);
                    }
                }
            }
        });

        if (impressions.length !== 0) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceImpressions',
                'ecommerce': {
                    'impressions': impressions
                }
            });
        }

        function addItem(itemGroupId, name, price, category, list) {
            addedImpressions.push(itemGroupId);
            item = {
                'name': name,
                'id': itemGroupId,
                'price': price,
                'category': category,
                'list': list,
                'position': position
            };
            position++;
            impressions.push(item);
        }

        function isIntoView(elem) {
            if (!$(elem).length) return false;

            let viewTop = $('.js-navbar-fixed-top').height() + $(window).scrollTop();
            let viewBottom = $(window).scrollTop() + document.documentElement.clientHeight;
            let elemTop = elem.offset().top;

            if ($(window).width() > XS_MAX_WIDTH) {
                viewBottom = viewBottom - $('.js-navbar-fixed-bottom').height();
            }

            if (elemTop > viewTop && elemTop < viewBottom) return true;
        }
    }

    function initToBasketBtn(hasItems, groupElement, itemGroup) {
        if (!hasItems) {
            if (itemGroup.getCount() === 0) {
                groupElement.find('.js-di-controls').hide();
                groupElement.find('.js-di-to-basket-btn').show();
            } else {
                groupElement.find('.js-di-to-basket-btn').hide();
                groupElement.find('.js-di-controls').show();
            }
        } else {
            if ($(window).width() <= XS_MAX_WIDTH) {
                groupElement.find('.js-di-items-controls').hide();

                if (itemGroup.getCount() === 0) {
                    groupElement.find('.js-di-to-basket-btn').show();
                } else {
                    groupElement.find('.js-di-to-basket-btn').hide();
                }
            } else {

                if (itemGroup.getCount() === 0) {
                    groupElement.find('.js-di-items-controls').hide();
                    groupElement.find('.js-di-to-basket-btn').show();
                } else {
                    groupElement.find('.js-di-to-basket-btn').hide();
                    groupElement.find('.js-di-items-controls').show();
                }
            }
        }
    }

    function checkDishesBanner() {
        let dishesBannerWasShown = localStorage.getItem('dishesBannerWasShown');

        if (dishesBannerWasShown === null) {
            $('.js-dl-banner').show();
        }

        $('.js-dl-banner-close').click(function () {
            localStorage.setItem('dishesBannerWasShown', 'yes');
            $('.js-dl-banner').hide();
        });
    }

    /**
     * При загрузке страницы открываем модальное окно, если есть хеш
     */
    function openAfterLoadPage() {
        const pathname = window.location.pathname;
        const urlEnd = pathname.substring(pathname.lastIndexOf("/") + 1);

        if (isFavoritesPage ? urlEnd !== AppService.tab.FAVORITES : urlEnd !== categoryPath) {
            $(".js-extended-dish[data-item-group-url='" + urlEnd + "']").click();
        }
    }

    const favoritesInit = () => {
        $.ajax({
            url: '/api/v5/sushi-user-favorite-item/all',
            method: 'GET'
        })
            .done(({result}) => {
                favorites = result;

                $('.dishes-item').each(function () {
                    const $groupElement = $(this);
                    const itemGroupId = $groupElement.data('item-group-id');

                    if (favorites.itemGroupIds.includes(itemGroupId)) {
                        $groupElement.find(".js_sc_favorites").addClass('active');
                    }
                });
            });
    };

    const changeFavorites = groupElement => {
        groupElement.find('.js_sc_favorites').click(event => {
            if (favorites !== undefined) {
                const $this = $(event.target);
                const itemGroupId = groupElement.data('itemGroupId');
                const sushiUserFavouriteItemRequest = {
                    itemGroupIds: [itemGroupId]
                };

                if (favorites.itemGroupIds.includes(itemGroupId)) {
                    $.ajax({
                        url: '/api/v5/sushi-user-favorite-item/delete',
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(sushiUserFavouriteItemRequest)
                    })
                        .done(() => {
                            $this.removeClass('active');
                            favorites.itemGroupIds = favorites.itemGroupIds.filter(elem => elem !== itemGroupId);

                            if (groupElement.data('is-favorites-page')) {
                                $('.modal.in').modal('hide');
                                document.getElementById(`${itemGroupId}Anchor`).style.display = 'none';
                            }
                        });
                } else {
                    $.ajax({
                        url: '/api/v5/sushi-user-favorite-item/add?fromWeb=true',
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(sushiUserFavouriteItemRequest)
                    })
                        .done(() => {
                            $this.addClass('active');
                            favorites.itemGroupIds.push(itemGroupId);
                        })
                        .fail(error => {
                            if (error.status === 401) {
                                $('.modal.in').modal('hide');
                                $('#modalStartAuthorize').modal('show');
                            }
                        });
                }
            }
        });
    };

    const setCategoryPath = () => {
        categoryPath = $('.js-dishes-list').data('category-path');
    };

    const setIsFavoritesPage = () => {
        isFavoritesPage = AppService.getGeneralTab() === AppService.tab.FAVORITES;
    };

    const setPathnameWithItemUrl = itemUrl => {
        const pathname = window.location.pathname;
        const urlEnd = pathname.substring(pathname.lastIndexOf("/") + 1);
        let newPathName;

        newPathName = isFavoritesPage ?
            urlEnd === AppService.tab.FAVORITES ?
                `${pathname}/${itemUrl}` :
                `${pathname.substring(0, pathname.lastIndexOf("/"))}/${itemUrl}` :
            urlEnd === categoryPath ?
                `${pathname}/${itemUrl}` :
                `${pathname.substring(0, pathname.lastIndexOf("/"))}/${itemUrl}`;

        history.pushState({}, document.title, newPathName);
    };

    /**
     * Возвращает в виде массива что выбрал пользователь
     * {
     *     item: {
     *         id: 'Id ItemDoc',
     *         price: 'его цена'
     *     }
     *     addons:[
     *         {
     *             id: 'Id добавки',
     *             price: 'Цена добавки'
     *         }
     *     ],
     *     count: 'Сколько раз юзер хочет этот товар с такой конфигурацией'
     *     price: 'цена за 1 единицу с item и адонами',
     *     totalPrice: 'Цена с учётом всего'
     * }
     * @param rootElement
     */
    function getChooseModalSelectData(rootElement) {
        let currentCount = rootElement.data("choose-count");
        if (!currentCount)
            currentCount = 1;

        let selectedItem = rootElement.find(".js-choose-item_input:checked");

        let item = {
            id: selectedItem.val(),
            price: parseFloat(selectedItem.data("price"))
        }
        let price = item.price;

        let addons = [];
        rootElement.find(".js-choose-addon_input:checked").each(function () {
            let addonElement = $(this);

            let addonId = addonElement.val();
            let addonPrice = parseFloat(addonElement.data('price'));

            price += addonPrice;
            addons.push({
                id: addonId,
                price: addonPrice
            });

        });

        return {
            item: item,
            addons: addons,
            count: currentCount,
            price: price,
            totalPrice: price * currentCount
        };
    }

    /**
     * Обновляет цену, а так же количество элементов у модалки по data тегам и отмеченным галочкам
     */
    function refreshChoose(rootElement) {
        let modalData = getChooseModalSelectData(rootElement);

        rootElement.find(".js-choose-count").html(modalData.count);
        rootElement.find(".js-choose-total_price").html(modalData.totalPrice);
    }

    /**
     * Изменить кол-во товаров с данной конфигурацией
     *
     * toAdd НА СКОЛЬКО элементов должно изменится(сюда передаётся либо 1 либо -1)
     */
    function changeChooseCount(rootElement, toAdd) {
        let currentCount = rootElement.data("choose-count");
        if (!currentCount)
            currentCount = 1;

        let newCount = currentCount + toAdd;
        if (newCount <= 0)
            newCount = 1;

        rootElement.data("choose-count", newCount);

        refreshChoose(rootElement);
    }

    function initChooses() {

        let chooseModal = $("#js-choose_modal");
        let chooseRoot = chooseModal.find(".js-choose-root");

        chooseRoot.find(".js-choose-item_input").click(() => refreshChoose(chooseRoot));
        chooseRoot.find(".js-choose-addon_input").click(() => refreshChoose(chooseRoot));

        chooseRoot.find(".js-choose-plus").click(() => changeChooseCount(chooseRoot, 1));
        chooseRoot.find(".js-choose-minus").click(() => changeChooseCount(chooseRoot, -1));

        chooseRoot.find(".js-choose-to_basket").click(function () {

            let data = getChooseModalSelectData(chooseRoot);

            let itemGroup = chooseRoot.data("choose-item_group");

            let groupElement = $(itemGroup.getId() + "Anchor");

            let addons = data.addons.map(addon => addon.id);

            itemGroup.setAddonItem(data.item.id, data.count, addons);

            initToBasketBtn(true, groupElement, itemGroup);

            chooseModal.modal('hide')
        });
    }


    /**
     * Заполняет и показывает модалку с выбором товара и айтема
     * @param itemGroup ItemGroup js объект
     * @param itemItems массив состоящий из предлагаемых предметов
     * @param itemAddons массив состоящий из предлагаемых добавок
     */
    function fillAndOpenChooseModal(itemGroup, itemItems, itemAddons) {
        let chooseModal = $("#js-choose_modal");
        let chooseRoot = chooseModal.find(".js-choose-root");

        let itemDiv = chooseModal.find("#js-choose_modal-item_div");
        let addonDiv = chooseModal.find("#js-choose_modal-addon_div");

        let itemDivList = chooseModal.find("#js-choose_modal-item_div_list");
        let addonDivList = chooseModal.find("#js-choose_modal-addon_div_list");

        itemDivList.empty();
        addonDivList.empty();

        chooseRoot.data("choose-item_group", itemGroup);
        chooseRoot.data("choose-count", "");


        function fillElement(array, listDiv, example, checkFirst = false) {
            for (let item of array) {
                let element = example.clone();
                element.removeAttr("id");
                element.css('display', '');

                let input = element.find(".js-choose-item_input, .js-choose-addon_input");
                input
                    .attr('value', item.id)
                    .attr('data-price', item.price)
                    .click(() => refreshChoose(chooseRoot));

                if (listDiv.children().length === 0 && checkFirst)
                    input.prop("checked", true);

                element.find(".js-choose_modal-item_title")
                    .html(item.title);

                element.find(".js-choose_modal-item_price")
                    .html(item.price);

                listDiv.append(element);

            }
        }

        fillElement(itemItems, itemDivList, chooseModal.find("#js-choose_modal-item_example"), true)
        if (itemItems.length > 1) {
            itemDiv.css('display', '');
        } else {
            itemDiv.hide();
        }

        if (itemAddons.length > 0) {
            fillElement(itemAddons, addonDivList, chooseModal.find("#js-choose_modal-addon_example"));
            addonDiv.css('display', '');
        } else {
            addonDiv.hide();
        }

        refreshChoose(chooseRoot);

        $(".modal.in").modal("hide");

        chooseModal.modal();
    }

    function init() {
        setCategoryPath();
        setIsFavoritesPage();

        $('#js-dishes-preview').click(function () {
            $(this).hide();
        });

        $('.js-dishes-item-preview').click(function () {
            showPreview($(this).find('img').data('preview'));
        });

        $('.js-dishes').each(function () {
            let groupElement = $(this);
            let itemGroupId = groupElement.data('itemGroupId');
            let itemGroup = CreateItemGroup();

            itemGroup.setGroupElement(groupElement)

            let itemElements = groupElement.find('.js-dishes-item');
            let list = groupElement.data('list');
            let name = groupElement.data('name');
            let price = groupElement.data('price');
            let category = groupElement.data('category');
            let position = parseInt(groupElement.data('position'));
            let variant;

            // Айтемы товара, которые у него есть в JSON
            let itemItems = groupElement.data('items');
            // Адоны(если есть, иначе пустой массив), тоже в json
            let itemAddons = groupElement.data('addons');

            if (groupElement.find('.js-toggle-label-content').length) {
                groupElement.find('.js-toggle-label').click(function () {
                    groupElement.find('.js-toggle-label-content').removeClass('mod-hidden');
                });

                groupElement.find('.js-toggle-label-content').click(function () {
                    groupElement.find('.js-toggle-label-content').toggleClass('mod-hidden');
                });
            }
            // Кнопка в корзину делает тоже самое что при нажатии на +
            groupElement.find('.js-di-to-basket-btn').click(function () {
                groupElement.find('.js-dishes-item-inc').trigger('click');
            });

            if (!itemAddons || itemAddons.length === 0) {

                let items = [];

                for (let item of itemItems) {
                    items[item.id] = CreateItem(itemGroup, groupElement);
                }

                itemGroup.setItems(items);
            }
            // Если у айтема только один айтем И нет адонов нет, то оставляем всё как есть
            if (itemItems.length <= 1 && itemAddons.length === 0) {
                let itemId = itemItems[0].id;

                groupElement.find('.js-dishes-item-inc').click(function () {
                    itemGroup.addItem(itemId);
                    ecommerceBeforeModal(list, itemGroupId, name, price, category, position);
                    ecommerceAfterModal(list, itemGroupId, name, price, category);
                    ecommerceClick(true, itemGroup.getCount(), itemGroupId, name, price, category);
                    initToBasketBtn(false, groupElement, itemGroup);
                });

                groupElement.find('.js-dishes-item-dec').click(function () {
                    ecommerceBeforeModal(list, itemGroupId, name, price, category, position);
                    ecommerceAfterModal(list, itemGroupId, name, price, category);
                    ecommerceClick(false, itemGroup.getCount(), itemGroupId, name, price, category);
                    itemGroup.removeItem(itemId);
                    initToBasketBtn(false, groupElement, itemGroup);
                });

                groupElement.find('.js-modal-dishes-item-inc').click(function () {
                    itemGroup.addItem(itemId);
                    ecommerceClick(true, itemGroup.getCount(), itemGroupId, name, price, category);
                    initToBasketBtn(false, groupElement, itemGroup);
                });

                groupElement.find('.js-modal-dishes-item-dec').click(function () {
                    ecommerceClick(false, itemGroup.getCount(), itemGroupId, name, price, category);
                    itemGroup.removeItem(itemId);
                    initToBasketBtn(false, groupElement, itemGroup);
                });
            }
            // Если у айтема есть добавки или выбор то показываем модалку выбора
            else {
                groupElement.find(".js-choose-button").click(() => fillAndOpenChooseModal(itemGroup, itemItems, itemAddons));
                itemGroup.setChooseItemCount(groupElement.data("item_group_count"));
            }

            groupElement.find('.js-extended-dish').click(function (event) {
                if (!event.target.classList.contains('js-dishes-dec') && !event.target.classList.contains('js-dishes-inc') && !event.target.classList.contains('js-dishes-item-dec') && !event.target.classList.contains('js-dishes-item-inc') && !event.target.classList.contains('js-di-to-basket-btn') && !event.target.classList.contains("js-choose-button") &&
                    event.target.classList.length > 0) {

                    if (itemElements.length === 0) {
                        ecommerceBeforeModal(list, itemGroupId, name, price, category, position);
                    } else {
                        ecommerceVariantBeforeModal(list, itemGroupId, name, price, category, position, variant);
                    }

                    $('#' + $(this).data('item-group-id')).modal('show');

                    if (itemElements.length === 0) {
                        ecommerceAfterModal(list, itemGroupId, name, price, category);
                    } else {
                        ecommerceVariantAfterModal(list, itemGroupId, name, price, category, variant);
                    }
                    setPathnameWithItemUrl($(this).data('item-group-url'));
                }
            });

            groupElement.find('.js-ywabi-item').on('click', event => {
                event.preventDefault();

                $('.js-extended-dish-modal').modal('hide');
                $('#' + $(event.target).data('item-group-id')).modal('show');
                setPathnameWithItemUrl($(event.target).data('url'));
            });

            groupElement.find('.js_sb_item_vk').on('click', () => {
                window.open(`https://vk.com/share.php?url=${window.location.href}`);
            });

            groupElement.find('.js_sb_item-fb').on('click', () => {
                window.FB.ui({
                    method: 'share',
                    href: window.location.href,
                }, function (response) {
                });
            });

            groupElement.find('.js_sb_item-ok').on('click', () => {
                window.open(`https://connect.ok.ru/offer?url=${window.location.href}`);
            });

            itemGroup.setElement(groupElement);
            itemGroup.setId(itemGroupId);

            // Для чего refresh? Мешает на странице с избранным.
            /*if (!isCategory) {
                itemGroup.setCallback(AppService.refresh);
            }*/
            itemGroups[itemGroupId] = itemGroup;

            initToBasketBtn(false, groupElement, itemGroup);
            initToBasketBtn(true, groupElement, itemGroup);

            $(window).resize(function () {
                initToBasketBtn(true, groupElement, itemGroup);
            });

            changeFavorites(groupElement);
        });

        ecommerceImpressions();

        $(window).scroll(ecommerceImpressions);

        checkDishesBanner();

        openAfterLoadPage();

        favoritesInit();

        initChooses();
    }

    //************ Public ************//
    return {
        init: init,
        ecommerceImpressions: ecommerceImpressions,
        //REMOVE THIS BEFORE COMMIT
        getData: getChooseModalSelectData
    };
})();

$(DishesService.init);